document.addEventListener('shopify:section:load', function(event) {
  const section = event.target;
  if (section.classList.contains('marquee-section')) {
    const speed = section.style.getPropertyValue('--scroll-duration');
    const direction = section.dataset.direction;
    
    // Reset animation
    const marqueeInner = section.querySelector('.marquee-inner');
    if (marqueeInner) {
      marqueeInner.style.animation = 'none';
      marqueeInner.offsetHeight; // Trigger reflow
      marqueeInner.style.animation = null;
    }
  }
});